import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoubleTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M22.9082 1.14002V9.90114H6.45119C6.39788 9.90114 6.34475 9.87458 6.31801 9.84783L1.31166 5.53389L6.29138 1.19322C6.31794 1.16666 6.37125 1.13991 6.42456 1.13991L22.9082 1.1401V1.14002ZM23.3875 0.074821H6.4511C6.1316 0.074821 5.83867 0.181258 5.59886 0.394318L0.2197 5.08122C-0.0732335 5.32084 -0.0732335 5.77354 0.2197 6.01335L5.59886 10.6733C5.83848 10.8864 6.1314 10.9928 6.4511 10.9928H23.4141C23.7336 10.9928 23.9999 10.7265 23.9999 10.407L23.9997 0.660557C23.9732 0.341059 23.7068 0.074707 23.3873 0.074707L23.3875 0.074821Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.9082 13.6229V22.3841H6.45119C6.39788 22.3841 6.34475 22.3575 6.31801 22.3307L1.31166 18.0168L6.29138 13.6761C6.31794 13.6496 6.37125 13.6228 6.42456 13.6228L22.9082 13.623V13.6229ZM23.3875 12.5577H6.4511C6.1316 12.5577 5.83867 12.6642 5.59886 12.8772L0.2197 17.5641C-0.0732335 17.8037 -0.0732335 18.2564 0.2197 18.4963L5.59886 23.1562C5.83848 23.3693 6.1314 23.4757 6.4511 23.4757H23.4141C23.7336 23.4757 23.9999 23.2094 23.9999 22.8899L23.9997 13.1435C23.9732 12.824 23.7068 12.5576 23.3873 12.5576L23.3875 12.5577Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgDoubleTab;
